<h1 mat-dialog-title>
  <fa-icon icon="exclamation-triangle" class="mr-3 dialog-notification-title-icon"></fa-icon>
  {{'kailo.an-error-occurred' | translate}}
</h1>
<div mat-dialog-content [innerHTML]="data"></div>
<div mat-dialog-actions class="action-buttons-row pb-4">
  <button mat-flat-button matDialogClose color="accent">
    {{'kailo.discard' | translate}}
  </button>
</div>